import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Sheet,
  SheetBody,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/sheet';
import { useState } from 'react';
import EventOrganizersList from '@Components/EventOrganizers/List';
import EventOrganizerForm from '@Components/EventOrganizers/Form';
import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';

const CREATE_FORM_ID = 'create-organizer-form';

export default function EventOrganizers() {
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <div>
      <Breadcrumbs
        navList={[
          { name: 'Events', href: '/events' },
          { name: 'Organizers', href: '/events/organizers' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Organizers</Heading>
        </div>
        <Sheet open={createOpen} onOpenChange={setCreateOpen}>
          <SheetTrigger asChild>
            <Button variant="primary">Create new organizer</Button>
          </SheetTrigger>

          <SheetContent side="right" className="w-full sm:max-w-xl">
            <SheetHeader>
              <SheetTitle>Create organizer</SheetTitle>
              <SheetDescription>
                Add a new organizer with their contact details.
              </SheetDescription>
            </SheetHeader>

            <SheetBody className="grow">
              <EventOrganizerForm
                onSuccess={() => setCreateOpen(false)}
                submitLabel="Create"
                formId={CREATE_FORM_ID}
                hideInternalActions
              />
            </SheetBody>

            <SheetFooter className="mt-4">
              <Button type="submit" form={CREATE_FORM_ID} variant="primary">
                Create
              </Button>
              <SheetClose asChild>
                <Button variant="secondary" type="button">
                  Close
                </Button>
              </SheetClose>
            </SheetFooter>
          </SheetContent>
        </Sheet>
      </div>

      <EventOrganizersList />
    </div>
  );
}
